import { Theme } from '@emotion/react';

interface IconProps {
  color?: string;
  size?: number;
  theme?: Theme;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export const GearIcon = ({ color, size = 40, onClick, className }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <g filter="url(#filter0_d_2237_195)">
        <path
          d="M38.7422 13.0156C38.9922 13.6953 38.7813 14.4531 38.2422 14.9375L34.8594 18.0156C34.9453 18.6641 34.9922 19.3281 34.9922 20C34.9922 20.6719 34.9453 21.3359 34.8594 21.9844L38.2422 25.0625C38.7813 25.5469 38.9922 26.3047 38.7422 26.9844C38.3985 27.9141 37.9844 28.8047 37.5078 29.6641L37.1406 30.2969C36.625 31.1562 36.0469 31.9688 35.4141 32.7344C34.9531 33.2969 34.1875 33.4844 33.5 33.2656L29.1485 31.8828C28.1016 32.6875 26.9453 33.3594 25.711 33.8672L24.7344 38.3281C24.5781 39.0391 24.0313 39.6016 23.3125 39.7188C22.2344 39.8984 21.125 39.9922 19.9922 39.9922C18.8594 39.9922 17.75 39.8984 16.6719 39.7188C15.9531 39.6016 15.4063 39.0391 15.25 38.3281L14.2735 33.8672C13.0391 33.3594 11.8828 32.6875 10.836 31.8828L6.49221 33.2734C5.80471 33.4922 5.03908 33.2969 4.57815 32.7422C3.94533 31.9766 3.36721 31.1641 2.85158 30.3047L2.4844 29.6719C2.00783 28.8125 1.59377 27.9219 1.25002 26.9922C1.00002 26.3125 1.21096 25.5547 1.75002 25.0703L5.13283 21.9922C5.04689 21.3359 5.00002 20.6719 5.00002 20C5.00002 19.3281 5.04689 18.6641 5.13283 18.0156L1.75002 14.9375C1.21096 14.4531 1.00002 13.6953 1.25002 13.0156C1.59377 12.0859 2.00783 11.1953 2.4844 10.3359L2.85158 9.70312C3.36721 8.84375 3.94533 8.03125 4.57815 7.26562C5.03908 6.70312 5.80471 6.51562 6.49221 6.73438L10.8438 8.11719C11.8906 7.3125 13.0469 6.64062 14.2813 6.13281L15.2578 1.67188C15.4141 0.960937 15.961 0.398438 16.6797 0.28125C17.7578 0.09375 18.8672 0 20 0C21.1328 0 22.2422 0.09375 23.3203 0.273438C24.0391 0.390625 24.586 0.953125 24.7422 1.66406L25.7188 6.125C26.9531 6.63281 28.1094 7.30469 29.1563 8.10938L33.5078 6.72656C34.1953 6.50781 34.961 6.70312 35.4219 7.25781C36.0547 8.02344 36.6328 8.83594 37.1485 9.69531L37.5156 10.3281C37.9922 11.1875 38.4063 12.0781 38.75 13.0078L38.7422 13.0156ZM20 26.25C21.6576 26.25 23.2473 25.5915 24.4194 24.4194C25.5915 23.2473 26.25 21.6576 26.25 20C26.25 18.3424 25.5915 16.7527 24.4194 15.5806C23.2473 14.4085 21.6576 13.75 20 13.75C18.3424 13.75 16.7527 14.4085 15.5806 15.5806C14.4085 16.7527 13.75 18.3424 13.75 20C13.75 21.6576 14.4085 23.2473 15.5806 24.4194C16.7527 25.5915 18.3424 26.25 20 26.25Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2237_195"
          x="-2.85449"
          y="0"
          width="45.7012"
          height="47.9922"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2237_195" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2237_195"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ArrowLeftIcon = ({
  color,
  size = 80,
  onClick,
  className,
  disabled,
  theme,
}: IconProps) => {
  const fillColor = disabled
    ? theme?.color[4] || color || 'currentColor'
    : theme?.color[3] || color || 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={disabled ? undefined : onClick}
      className={className}
      style={{ cursor: disabled ? 'default' : 'pointer' }}
    >
      <g filter="url(#filter0_d_2699_2769)">
        <path
          d="M6 35.4641C3.33333 33.9245 3.33333 30.0755 6 28.5359L54 0.823082C56.6667 -0.716522 60 1.20798 60 4.28718L60 59.7128C60 62.792 56.6667 64.7165 54 63.1769L6 35.4641Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2699_2769"
          x="0"
          y="0.28125"
          width="64"
          height="71.4375"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2699_2769" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2699_2769"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ArrowRightIcon = ({
  color,
  size = 80,
  onClick,
  className,
  disabled,
  theme,
}: IconProps) => {
  const fillColor = disabled
    ? theme?.color[4] || color || 'currentColor'
    : theme?.color[3] || color || 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={disabled ? undefined : onClick}
      className={className}
      style={{ cursor: disabled ? 'default' : 'pointer' }}
    >
      <g filter="url(#filter0_d_2699_2655)">
        <path
          d="M58 28.5359C60.6667 30.0755 60.6667 33.9245 58 35.4641L10 63.1769C7.33333 64.7165 4 62.792 4 59.7128L4 4.28718C4 1.20798 7.33333 -0.716519 10 0.823082L58 28.5359Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2699_2655"
          x="0"
          y="0.28125"
          width="64"
          height="71.4375"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2699_2655" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2699_2655"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
